document.addEventListener("DOMContentLoaded", function () {

  /* LIGHTBOX */
  const images = document.querySelectorAll(".editorial-gallery img");
  const lightbox = document.getElementById("lightbox");
  const lightboxImg = document.querySelector(".lightbox-img");

  let currentIndex = 0;
  let imgArray = [];

  images.forEach((img, index) => {
    imgArray.push(img.src);

    img.addEventListener("click", () => {
      currentIndex = index;
      lightbox.style.display = "flex";
      lightboxImg.src = img.src;
    });
  });

  document.querySelector(".close").onclick = () => {
    lightbox.style.display = "none";
  };

  document.querySelector(".lightbox-prev").onclick = () => {
    currentIndex = (currentIndex - 1 + imgArray.length) % imgArray.length;
    lightboxImg.src = imgArray[currentIndex];
  };

  document.querySelector(".lightbox-next").onclick = () => {
    currentIndex = (currentIndex + 1) % imgArray.length;
    lightboxImg.src = imgArray[currentIndex];
  };

  /* CAROUSEL (3 items visible) */
  document.querySelectorAll(".carousel").forEach(carousel => {
    const track = carousel.querySelector(".carousel-track");
    const items = carousel.querySelectorAll(".carousel-item");

    let index = 0;
    const visibleItems = 3;
    const maxIndex = items.length - visibleItems;

    carousel.querySelector(".next").onclick = () => {
      index = (index < maxIndex) ? index + 1 : 0;
      track.style.transform = `translateX(-${(index * 100) / visibleItems}%)`;
    };

    carousel.querySelector(".prev").onclick = () => {
      index = (index > 0) ? index - 1 : maxIndex;
      track.style.transform = `translateX(-${(index * 100) / visibleItems}%)`;
    };
  });

});